// extracted by mini-css-extract-plugin
export default {"container":"MainContent_container__RsmVx","content1":"MainContent_content1__g7igg","devider":"MainContent_devider__psqs6","content2":"MainContent_content2__88XL-"};